'use client';
import styled from 'styled-components';
import { screenReaderOnly } from '../../utility-classes';
export const ScreenReaderOnly = styled.span `
  ${screenReaderOnly};
`;
//# sourceMappingURL=index.js.map